<template>
  <div v-if="status == 'RUNNING'">
    <p
      class="mb-6 text-center text-xl font-medium text-ontick-carbon-900 dark:text-gray-200"
    >
      Parar investimento
    </p>

    <div
      class="mx-auto mb-6 w-11/12 text-ontick-carbon-900 dark:text-ontick-graphite-300 sm:w-5/6 md:w-4/6"
    >
      <p class="flex">
        <span class="pr-2 text-ontick-green-500" v-html="$icons.check"></span>
        Todas as posições abertas serão fechadas.
      </p>
      <p class="flex">
        <span class="pr-2 text-ontick-green-500" v-html="$icons.check"></span>
        Todas as ordens pendentes serão canceladas.
      </p>
    </div>

    <p class="text-center text-sm text-ontick-steel-900 dark:text-gray-300">
      Você está prestes a desligar este investimento
    </p>

    <div v-if="account_type == 'PRD'" class="mt-6 mb-6">
      <ontick-text align="center"
        >Digite "<span class="font-medium italic text-ontick-blue-500"
          >confirmar</span
        >"para parar todos os investimentos</ontick-text
      >
      <div class="mx-auto mt-4 w-9/12">
        <input
          type="text"
          v-model="confirmationText"
          @keyup="keyupConfirmationText($event)"
          class="text-ontick-steel=900 input_form focus:outline-none block w-full appearance-none rounded-md bg-ontick-steel-100 px-4 py-3 dark:bg-ontick-carbon-500 dark:text-gray-200 sm:text-sm"
          placeholder='Digite "confirmar"'
          maxlength="9"
          ref="inputConfirmationText"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: { type: String },
    account_type: { type: String },
  },
  data() {
    return {
      confirmationText: "",
    };
  },

  methods: {
    keyupConfirmationText(event) {
      this.$emit("keyConfirm", event);
    },
  },
};
</script>

<style></style>
